<style lang="scss" scoped>
@import '../assets/style/_mixin.scss';
.home_container {
  width: 100%;
  height: calc(100% - 56px);
}
.home_header_title {
  @include fluid-font-size(24px, 36px);
}
.home_body {
  height: calc(100% - 4rem);
  padding-top: 2rem;
}
.badge_value {
  margin-right: -.2rem;
  margin-top: -.09rem;
  margin-bottom: -.09rem;
  padding-bottom: -.05rem;
  border-top-right-radius: .25rem;
  border-bottom-right-radius: .25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  // position: relative;
  // top: 1px;
  // right: 1px;
}
</style>

<template>
  <div class="home_container container pt-3">
    <div v-if="loaded.fbGroup">
      <div class="d-flex justify-content-between align-items-center border-bottom border-gray pb-1">
        <span class="home_header_title text-success font-weight-bold">Multi-site VPN</span>
        <b-button
          variant="outline-primary"
          size="sm"
          @click="showModal('addGroupModalRef')"
          v-if="filteredGroup.length > 0"
        >Create A New Group</b-button>
      </div>
      <div class="home_body pt-3">
        <div
          v-if="filteredGroup.length === 0"
          class="container d-flex justify-content-center"
        >
          <b-button
            variant="outline-primary"
            size="lg"
            @click="showModal('addGroupModalRef')"
          >
            <strong>Create Your First Group</strong>
          </b-button>
        </div>
        <Card4Groups v-for="g in filteredGroup" :key="g['.key']" :data="g" />
      </div>
    </div>
    <b-modal
      title="Create A New Group"
      ref="addGroupModalRef"
      centered
      @hidden="initNewGroupInfo"
    >
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="type-group">Server / Name</label>
          </b-col>
          <b-col sm="8">
            <b-input-group id="type-group">
              <b-dropdown size="sm" :text="options.server[newGroupInfo.server]" variant="success" slot="prepend">
                <b-dropdown-item-button
                  :key="key"
                  v-for="(value, key) in options.server"
                  @click="() => {newGroupInfo.server = key}"
                >
                  {{ value }}
                </b-dropdown-item-button>
              </b-dropdown>
              <input
                name="name"
                v-model="newGroupInfo.name"
                v-validate="{required: true, not_in: _map (filteredGroup, 'name')}"
                :class="{ 'form-control': true, 'form-control-sm': true, 'border-danger': errors.has('name') }"
              />
            </b-input-group>
            <small v-show="errors.has('name')" class="d-block text-danger text-right">
              <font-awesome-icon :icon="faExclamationCircle" v-show="errors.has('name')" />
              {{ errors.first('name') }}
            </small>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="type-pwd">
              Password
            </label>
          </b-col>
          <b-col sm="8">
            <input-validator
              type="password"
              id="type-pwd"
              name="password"
              size="sm"
              :value.sync="newGroupInfo.password"
              rule="required|alpha_num"
            />
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4">
            <label for="type-desc">
              Description
            </label>
          </b-col>
          <b-col sm="8">
            <input-validator
              id="type-desc"
              name="description"
              size="sm"
              :value.sync="newGroupInfo.description"
              rule="required"
            />
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="float-right">
        <b-button size="sm" variant="secondary" class="mr-2" @click="hideModal('addGroupModalRef')">Cancel</b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="clickCreateNewGroup"
          :disabled="newGroupInfoValidation"
        >OK</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash'
import { mapState } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid'
import InputValidator from '@/components/InputValidator'
import Card4Groups from '@/components/Card4Groups'
import { getDbRef, getDbTime } from '@/firebaseRef'

export default {
  name: 'home',
  components: {
    Card4Groups,
    FontAwesomeIcon,
    InputValidator
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  firebase: {
    fbGroup: {
      source: getDbRef('group'),
      readyCallback: function () {
        this.loaded.fbGroup = true
      }
    }
  },
  data () {
    return {
      /* icon */
      faExclamationCircle,
      /** user-defined group info */
      newGroupInfo: {
        server: 'asia',
        name: '',
        password: '',
        description: ''
      },
      rmGroupInfo: null,
      /* options */
      options: {
        server: {
          'asia': 'Asia',
          'eu': 'Europe'
        }
      },
      /* data loading's status, true for loaded. */
      loaded: {
        fbGroup: false
      },
      fakeGroup: [1]
    }
  },
  computed: {
    filteredGroup () {
      const rules = {
        deleted: false,
        ...(this.useRole === 'admin' ? {} : { ownerID: this.uid })
      }
      return _.filter(this.fbGroup, rules)
    },
    newGroupInfoValidation () {
      const ngi = {...this.newGroupInfo}
      const isInputStrEmpty = _.compact(_.values(ngi)).length < _.size(ngi) - 1 // check if any prop of newGroupInfo is ''
      const isInputError = this.errors.any() || this.errors.has('name') // the name field is uncabable to sync to all, so hard coding here QQ
      // console.log('isInputError', isInputError, this.errors)
      return isInputStrEmpty || isInputError
    },
    ...mapState({
      uid: (state) => state.user.uid,
      useRole: (state) => state.user.role
    })
  },
  methods: {
    _map (collection, iter) {
      return _.map(collection, iter)
    },
    showModal (modalRef) {
      this.$refs[modalRef].show()
      this.clearErrorMsg()
    },
    hideModal (modalRef) {
      this.$refs[modalRef].hide()
    },
    clickCreateNewGroup () {
      this.hideModal('addGroupModalRef')
      const pushData = {
        ...this.newGroupInfo,
        ownerID: this.uid,
        createdAt: getDbTime(),
        deleted: false
      }
      console.log(pushData)
      getDbRef('group').push(pushData)
    },
    initNewGroupInfo () {
      /* initialize newGroupInfo */
      this.newGroupInfo = {
        server: 'asia',
        name: '',
        password: '',
        description: ''
      }
    },
    clickDeleteGroup (target) {
      this.showModal('deleteGroupModalRef')
      this.rmGroupInfo = target
    },
    clickConfirm () {
      this.hideModal('deleteGroupModalRef')
    },
    clearErrorMsg () {
      /**
       * Clear newGroupInfo past errors.
       * p.s.
       *  To accomplish clear here (which is parent comp),
       *  this comp gotta provide() the $validator here to the InputValidator (which is child comp)!
       *  So that the $validator can be sync.
      */
      this.errors.clear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue